export default function getResource(label) {
    const resources = {
        items: 'Articles',
        item: 'Article',
        substitution: 'Préférences de substitution'
    };

    return resources[label];
}
